import { styled } from "styled-components";
import rightTail from '../../assets/right_tail.svg';

const Wrapper = styled.div`
  position: relative;
  padding: 10px 13px;
  padding-right: 20px;
  border-radius: 20px;
  background: #9738FF;
  margin-bottom: 20px;
  width: fit-content;
  margin-left: auto;
  p {
    padding: 0px;
    margin: 0px;
    padding-left: 10px;    
    color: #FFF;
  }
  &::after {
    content: '';
    position: absolute;
    bottom: -11px;
    right: -16px;
    width: 30px;
    height: 30px;
    background-image: url(${rightTail});
    background-repeat: no-repeat;
  }
`;

const AnswerText = ({ message, form }) => {
  return (
    <Wrapper>
      <p dangerouslySetInnerHTML={{__html: Array.isArray(message) ? message.join('<br />') : message}} />
      {form ? form : false}
    </Wrapper>
  );
};

export default AnswerText;
